import request from "@/utils/Request";
import type {
  HistoryListRequest,
  HistoryListResponse,
  ChatHistoryResponse,
} from "./Types";

export const getHistoryList = (page: number, size: number) => {
  const requestData: HistoryListRequest = {
    page: page,
    size: size,
  };
  return request.get<HistoryListResponse>("/api/session/session_list", {
    params: requestData,
  });
};

export const getChatHistory = (
  sessionId: number,
  page: number,
  size: number
) => {
  return request.get<ChatHistoryResponse>("/api/session/chat_list", {
    params: { session_id: sessionId, page: page, size: size },
  });
};
